import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FetchedData, genFetchedData } from '../../../redux/fetchedData';
import { CounteragentItem, ICheckCounteragentIsExistData } from './types';

export type counteragentsState = {
  counteragentData: FetchedData<CounteragentItem>;
  checkCounteragentIsExist: FetchedData<ICheckCounteragentIsExistData>;
};

export const initialState: counteragentsState = {
  counteragentData: genFetchedData<CounteragentItem>(null),
  checkCounteragentIsExist: genFetchedData<ICheckCounteragentIsExistData>(null),
};

const counteragentSlice = createSlice({
  name: 'Counteragent',
  initialState,
  reducers: {
    setCounteragentData(
      state,
      action: PayloadAction<counteragentsState['counteragentData']>,
    ) {
      state.counteragentData = action.payload;
    },
    setcheckCounteragentIsExist(
      state,
      action: PayloadAction<counteragentsState['checkCounteragentIsExist']>,
    ) {
      state.checkCounteragentIsExist = action.payload;
    },
    clearCheckCounteragentIsExistData(state) {
      state.checkCounteragentIsExist = genFetchedData<ICheckCounteragentIsExistData>(null);
    },
  },
});

export const {
  setCounteragentData,
  setcheckCounteragentIsExist,
  clearCheckCounteragentIsExistData,
} = counteragentSlice.actions;
export const counteragentReducer = counteragentSlice.reducer;
